export enum COMPANY_TYPE_ENUM {
  HEADQUARTER = 1,
  COMPANY_BRANCH = 2,
}
